<div class="contact-content">
    <div class="back-button">
        <mat-icon routerLink="/onsaleperiod">arrow_back</mat-icon>
    </div>
    <div>
        <h3>AKCIÓ MÓDOSÍTÁSA</h3>
    </div>
    <div class="contact-form">
        <form novalidate [formGroup]="saleForm!">
            <div class="field-container">
                <div class="field">
                    <span>Akció neve</span>
                    <div class="data">
                        <input
                            class="form-control"
                            formControlName="onSaleName"
                            id="onSaleName"
                            required
                            type="text"
                            [(ngModel)]="onSalePeriod.name"
                        />
                    </div>
                </div>
            </div>
            <div class="field-container">
                <div class="field">
                    <span>Akció kezdő dátuma</span>
                    <div class="data">
                        <input
                            class="form-control"
                            formControlName="onSaleStartDate"
                            id="onSaleStartDate"
                            pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
                            placeholder="YYYY-MM-DD"
                            required
                            type="date"
                            [ngModel]="onSalePeriod.startDate | date: 'yyyy-MM-dd'"
                            (change)="onChangeStartDate($event)"
                            (ngModel)="onSalePeriod.startDate = $any($event).target.valueAsDate"
                        />
                    </div>
                </div>
            </div>
            <div class="field-container">
                <div class="field">
                    <span>Akció Befejező dátuma</span>
                    <div class="data">
                        <input
                            class="form-control"
                            formControlName="onSaleEndDate"
                            id="onSaleEndDate"
                            pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
                            placeholder="YYYY-MM-DD"
                            required
                            type="date"
                            [ngModel]="onSalePeriod.endDate | date: 'yyyy-MM-dd'"
                            (change)="onChangeEndDate($event)"
                            (ngModel)="onSalePeriod.endDate = $any($event).target.valueAsDate"
                        />
                    </div>
                </div>
            </div>
        </form>
    </div>

    <h3>AKCIÓ ELEMEINEK MÓDOSÍTÁSA</h3>
    <div class="drag-and-drop-container">
        <div class="search-main-container">
            <div class="search-bar">
                <div class="search-tool">
                    <mat-icon aria-hidden="false" aria-label="keyboard_arrow_right icon" fontIcon="search" />
                    <input placeholder="Szerző, cím neve" type="search" [(ngModel)]="searchText" />
                </div>
            </div>
            <div class="title">
                <h3>{{ onSalePeriod.name }} csomag tartalma</h3>
            </div>
        </div>
        <div class="drag-and-drop">
            <div class="products-container">
                <div class="products">
                    @for (product of products | filter: searchText; track product) {
                        <div class="product">
                            {{ product.author + ': ' + product.title }}
                            <mat-icon (click)="addProductToOnSale(product)">add_circle_outline</mat-icon>
                        </div>
                    }
                </div>
            </div>
            <div class="title-mobile">
                <h3>{{ onSalePeriod.name }} csomag tartalma</h3>
            </div>
            <div class="products-container">
                <div class="products">
                    @for (product of updateableProducts; track product) {
                        <div class="product">
                            {{ product.author + ': ' + product.title }}
                            <mat-icon (click)="deleteFromOnSaleProductList(product)">remove_circle_outline</mat-icon>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
    <div class="field-container" [ngStyle]="{ 'margin-top': '8px' }">
        <div class="field" [ngStyle]="{ 'justify-content': 'center', 'margin-top': '8px', 'margin-bottom': '8px' }">
            <div class="data" [ngStyle]="{ 'justify-content': 'center' }">
                <button
                    [disabled]="!saleForm?.valid"
                    [ngStyle]="{ background: '#e8fcfd', border: '1px solid #0E8388', 'font-weight': 'bold', width: '100%' }"
                    (click)="updateOnSalePeriod()"
                >
                    AKCIÓ ELEMEINEK MÓDOSÍTÁSA
                </button>
            </div>
        </div>
    </div>
</div>
